import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import type { SessionActionsSlice, SessionDataSlice, SessionStore } from './session.types'

const createSessionDataSlice = (): SessionDataSlice => ({
  // Initial State
  token: null,
  isLoading: false,
  error: null,
  lastFetched: null,
})

const createSessionActionsSlice = (): SessionActionsSlice => ({
  // Actions
  setToken: (token: string | null) =>
    useSessionStore.setState((state) => {
      state.token = token
      state.lastFetched = token ? Date.now() : null
    }),

  setLoading: (loading: boolean) =>
    useSessionStore.setState((state) => {
      state.isLoading = loading
    }),

  setError: (error: string | null) =>
    useSessionStore.setState((state) => {
      state.error = error
    }),

  clearToken: () =>
    useSessionStore.setState((state) => {
      state.token = null
      state.lastFetched = null
      state.error = null
    }),
})

export const useSessionStore = create<SessionStore>()(
  devtools(
    immer(() => ({
      ...createSessionDataSlice(),
      ...createSessionActionsSlice(),
    })),
    {
      name: 'SessionStore',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
